import React from "react";
import { Grid } from "@material-ui/core";
import ArticleCard from "components/atoms/ArtcileCard";
import { Article } from "API";

type Props = {
  articles: Article[] | undefined;
  showCategory?: boolean;
  lastArticleRef?: (node: HTMLDivElement) => void;
};

export default function Page(props: Props) {
  const { articles, showCategory, lastArticleRef } = props;

  return (
    <>
      <Grid container spacing={3}>
        {articles &&
          articles
            .filter((article) => article)
            .map((article: Article, key, arr) => (
              <Grid
                item
                xs={key > 3 ? 6 : 12}
                sm={key > 3 ? 6 : 12}
                md={3}
                lg={3}
                key={key}
                ref={key === arr.length - 1 ? lastArticleRef : undefined}
              >
                <ArticleCard article={article} showCategory={showCategory} />
              </Grid>
            ))}
      </Grid>
    </>
  );
}

Page.defalutProps = {
  showCategory: false,
};
